// src/components/Common/DownloadOptionsDialog.jsx - Language and Simplification Options
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import { Close, Language } from '@mui/icons-material';
import { useThemeMode } from '../../contexts/ThemeModeContext';

const DownloadOptionsDialog = ({ open, onClose, onDownload, reportType = 'report' }) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  const cardBg = isDark ? '#1E1E1E' : '#FFFFFF';
  const textColorPrimary = isDark ? '#F1F5F9' : '#0F172A';
  const textColorSecondary = isDark ? '#CBD5E1' : '#475569';
  const cardBorder = isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.08)';

  const [language, setLanguage] = useState('en');
  const [simplify, setSimplify] = useState(false);

  const handleDownload = () => {
    const finalSimplify = language !== 'en' ? true : simplify;
    onDownload({ language, simplify: finalSimplify });
    handleClose();
  };

  const handleClose = () => {
    setLanguage('en');
    setSimplify(false);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { xs: '95vw', sm: '420px' },
          maxWidth: '440px !important',
          maxHeight: '85vh',
          borderRadius: '12px',
          bgcolor: cardBg,
          color: textColorPrimary,
          border: cardBorder
        }
      }}
    >
      <DialogTitle sx={{ px: 2, py: 1.25, borderBottom: cardBorder }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <Language color="primary" sx={{ fontSize: 20 }} />
            <Typography variant="subtitle1" fontWeight={700} sx={{ color: textColorPrimary, fontSize: '0.95rem' }}>
              Download Report
            </Typography>
          </Box>
          <IconButton onClick={handleClose} size="small" sx={{ p: '3px', color: textColorSecondary }}>
            <Close sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 2, py: 1.5 }}>
        <Typography variant="body2" sx={{ color: textColorPrimary, mb: 1, fontSize: '0.85rem' }}>
          <strong>Coming Soon:</strong> Report translation and simplification features are currently under development. 
          Reports will be downloaded in English.
        </Typography>

        <Typography variant="caption" sx={{ color: textColorSecondary, display: 'block', fontSize: '0.78rem' }}>
          Click "Download PDF" to proceed with English download.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.25, borderTop: cardBorder }}>
        <Button onClick={handleClose} sx={{ height: 30, fontSize: '0.8rem', borderRadius: '6px', textTransform: 'none', px: 1.5 }}>
          Cancel
        </Button>
        <Button 
          onClick={handleDownload} 
          variant="contained" 
          sx={{
            height: 30,
            fontSize: '0.8rem',
            borderRadius: '6px',
            textTransform: 'none',
            px: 1.75,
            bgcolor: '#0D9488',
            '&:hover': { bgcolor: '#0F766E' }
          }}
        >
          Download PDF
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadOptionsDialog;
